import {
  Dialog,
  DialogContent,
  DialogTitle,
  Link,
  Tooltip,
} from '@mui/material';
import { useState } from 'react';
import { CheckoutModel } from 'src/core/model/quarter-overview.model';
import { useTranslation } from 'react-i18next';
import { CheckoutTable } from '../checkout-table/checkout-table';

type Props = {
  title: string;
  list?: CheckoutModel[];
};

export function CheckoutStats(props: Readonly<Props>): React.JSX.Element {
  const { title, list = [] } = props;
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Tooltip
        title={list.length === 0 && t('quarter-overview.stats.no-items')}>
        <span>
          <Link
            disabled={list.length === 0}
            component="button"
            color="inherit"
            underline="hover"
            onClick={() => setIsOpen(true)}>
            {title}
          </Link>
        </span>
      </Tooltip>

      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle>{title}</DialogTitle>

        <DialogContent>
          <CheckoutTable list={list} />
        </DialogContent>
      </Dialog>
    </>
  );
}
